import Lottie from 'lottie-react';
import Box from '@mui/material/Box/Box';
import { UIElement } from '@adyen/adyen-web';
import Backdrop from '@mui/material/Backdrop/Backdrop';

import loader from '../../../../../../assets/grey-loader.json';
import { AdyenComponentContainer } from '../AdyenComponentContainer/AdyenComponentContainer';

import './styles.scss';

interface AdyenThreeDSComponentProps {
  threeDSComponent: UIElement | null;
}

export function AdyenThreeDSComponent({ threeDSComponent }: AdyenThreeDSComponentProps) {
  if (!threeDSComponent) {
    return null;
  }

  return (
    <Backdrop
      className="three-ds-container"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      transitionDuration={250}
      open={Boolean(threeDSComponent)}
    >
      {threeDSComponent && (
        <Box className="three-ds-content" sx={{}}>
          <Lottie animationData={loader} className="loader-animation" size={50} />
          <AdyenComponentContainer element={threeDSComponent} hideLoader className="full-height" />
        </Box>
      )}
    </Backdrop>
  );
}
